/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { useApp, ToggleSwitch } from "../../a";
import "./styles.scss";

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'theme-selector';

/**
 * This is the component description.
 */
const ThemeSelector = ({
  id,
  className: userClassName,
  style,
  themes
}) => {
  const {
    userTheme,
    setPreferredTheme
  } = useApp();
  const loopThemes = useCallback(() => {
    const current = themes.indexOf(userTheme);
    setPreferredTheme(themes[(current + 1) % themes.length]);
  }, [userTheme]);
  return /*#__PURE__*/React.createElement("div", {
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    id: id,
    style: style
  }, /*#__PURE__*/React.createElement("span", {
    className: "c-x x-paragraph"
  }, userTheme && userTheme[0].toUpperCase() + userTheme.slice(1), ' ', "Theme"), /*#__PURE__*/React.createElement(ToggleSwitch, {
    checked: userTheme === 'dark',
    handleOnChange: loopThemes,
    inputId: "theme-toggle"
  }));
};
ThemeSelector.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The themes and the order in which they appear
   */
  themes: PropTypes.arrayOf(PropTypes.string)
};
ThemeSelector.defaultProps = {
  themes: ['light', 'dark']
};
export default ThemeSelector;